import { AnaColumn } from "../forms-template.service";

export const Azienda: AnaColumn[] = [
  {
    itemType: "group", colCount: "1", data: [
      {
        type: 'button',
        dataField: "ButtonAziendaUseer",
        width: 50, hideOnEdit: true,
        colAlignment: 'center',
        disableOnUpdate: true,
        button:
        {
          event: "OptionalIconButtonClick",
          name: "aziendaUtenti",
          hint: "Gestione Utenti",
          icon: "fa fa-user"
        }
      },
      {
        type: 'button',
        dataField: "ButtonDBConfig",
        width: 50,
        hideOnEdit: true,
        colAlignment: 'center',
        disableOnUpdate: true,
        button:
        {
          event: "ButtonDBConfig",
          name: "databaseConfig",
          hint: "Configurazione Manuale Database Aziendale",
          icon: "bi bi-database-fill-gear"
        }
      },
      {
        type: 'button',
        dataField: "ButtonXmlLog",
        dataType: "",
        caption: "",
        width: 50,
        hideOnEdit: true,
        disableOnUpdate: true,
        button:
        {
          event: "ButtonXmlLog",
          name: "xmlConsumptionLog",
          hint: "Consumo Registri XML",
          icon: "bi bi-speedometer"

        }
      },
      { type: 'campo', hideOnEdit: true, disabled: true, disableOnUpdate: true, width: "20", labelPosition: 'start', dataField: "id", dataType: "", caption: "ID" },
      { type: 'campo', hideOnEdit: true, disabled: true, disableOnUpdate: true, width: "400", dataField: "alias", dataType: "", caption: "Alias" },
      {
        type: 'campo', maxLength: "35", dataField: "descrizione", dataType: "", caption: "Descrizione", width: "400",
        validation: [{ type: "required", message: "Campo Obbligatorio" }],
      },
      { type: 'campo', colVisible: false, hideOnEdit: true, dataField: "note", dataType: "", colSpan: "2" },
      {
        type: 'campo', disableOnUpdate: false, maxLength: "16", dataField: "codiceFiscaleAzienda", caption: "Codice Fiscale", dataType: "", colSpan: "2",
        validation: [{ type: "required", message: "Campo Obbligatorio" }],
      },
      {
        type: 'campo', disableOnUpdate: false, colVisible: false, maxLength: "16", dataField: "dataUltimaRichiestaAttivazioneUTC", caption: "dataUltimaRichiestaAttivazioneUTC", dataType: "", visible: false,
      },
      {
        type: 'campo', disableOnUpdate: false, colVisible: false, maxLength: "16", dataField: "isDatabaseZucchettiConfigured", caption: "isDatabaseZucchettiConfigured", dataType: "", visible: false,
      },
      {
        type: 'campo', defaultValue: true,
        editorType: 'dxCheckBox', hideOnEdit: false, dataField: "isAttiva", caption: "Attiva", dataType: "boolean", colSpan: "2", colAlignment: 'center',
        horizontalAlignment: 'center',
        verticalAlignment: 'center',
      },
      {
        type: 'button',
        dataField: "ButtonEmailAttivazioneZucchettiDB",
        width: 50, hideOnEdit: true,
        colAlignment: 'center',
        horizontalAlignment: 'center',
        verticalAlignment: 'center',
        disableOnUpdate: true,
        colVisible: true,
        button:
        {
          event: "ButtonEmailAttivazioneZucchettiDB",
          name: "ButtonEmailAttivazioneZucchettiDB",
          hint: "Invia email per attivazione database zucchetti",
          icon: "dx-icon dx-icon-email"
        }
      },
    ]
  }
]
